export var myExpenseChart = {
    series: [{
        name: "Inflation",
        data: [9000, 11000, 9000, 8000, 12500, 10000],
        color: "var(--theme-color5)",
    },],
    chart: {
        height: 220,
        type: "bar",
        background: "var(--g1-color)",
        toolbar: {
            show: false,
        },
    },
    grid: {
        show: true,
        xaxis: {
            lines: {
                show: false,
            },
        },
        yaxis: {
            lines: {
                show: false,
            },
        },
    },
    plotOptions: {
        bar: {
            borderRadius: 10,
            dataLabels: {
                position: "top",
            },
        },
    },
    dataLabels: {
        enabled: true,
        formatter: function (val) {
            return val + "";
        },
        offsetY: -20,
        style: {
            fontSize: "12px",
            colors: ["#304758"],
        },
    },

    xaxis: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
        position: "bottom",
        axisBorder: {
            show: true,
        },
        axisTicks: {
            show: true,
        },
        crosshairs: {
            fill: {
                type: "gradient",
                gradient: {
                    colorFrom: "#D8E3F0",
                    colorTo: "#BED1E6",
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5,
                },
            },
        },
        tooltip: {
            enabled: false,
        },
    },
    yaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
            formatter: function (val) {
                return val + "";
            },
        },
    },
};
